import { Col, Row } from "react-bootstrap"

import NotificationEventSelection from "./NotificationEventSelection"
import NotificationMethodSelection from "./NotificationMethodSelection"
import NotificationServiceSelection from "./NotificationServiceSelection"
import NotificationSettings from "../../../api/Notifications/Model/NotificationSettings"
import ToggleSwitch from "../../FormattedInputs/ToggleSwitch"

interface NotificationsSelectionProps extends NotificationSettings {
  participationId?: number
  canViewOrderTrackingGrid?: boolean
  onCheckNotificationService: (notificationServiceId: number, value: boolean) => void
  onCheckNotificationEvent: (notificationEventId: number, value: boolean) => void
  onCheckNotificationMethod: (notificationMethodId: number, value: boolean) => void
  onCheckShowNotifications: (value: boolean) => void
}

function NotificationSelection(props: NotificationsSelectionProps) {
  const {
    participationId,
    showNotifications,
    canViewOrderTrackingGrid,
    checkedNotificationServiceIDs,
    checkedNotificationEventIDs,
    checkedNotificationMethodIDs,
    onCheckNotificationService,
    onCheckNotificationEvent,
    onCheckNotificationMethod,
    onCheckShowNotifications,
  } = props

  return (
    <>
      <Row>
        <Col className="pb-2">
          <p className="mb-0">
            Should we notify you about services and events?
            <ToggleSwitch
              className="ml-2"
              on="Yes"
              off="No"
              checked={showNotifications}
              onCheck={onCheckShowNotifications}
            />
          </p>
          <em className="small">
            Note: Your ability to receive a notification will depend on your access level. Contact your Administrator if
            you have questions about your access level.
          </em>
        </Col>
      </Row>
      {showNotifications && (
        <>
          <Row>
            <Col>
              <NotificationServiceSelection
                participationId={participationId}
                selectedIDs={checkedNotificationServiceIDs}
                onChange={onCheckNotificationService}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <NotificationEventSelection
                selectedIDs={checkedNotificationEventIDs}
                canViewOrderTrackingGrid={canViewOrderTrackingGrid}
                onChange={onCheckNotificationEvent}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <NotificationMethodSelection
                selectedIDs={checkedNotificationMethodIDs}
                onChange={onCheckNotificationMethod}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  )
}

NotificationSelection.defaultProps = {
  canViewOrderTrackingGrid: false,
  participationId: undefined,
}

export default NotificationSelection
